export default {
  toasts: {
    success: 'Card cadou utilizat cu succes.',
    error: 'Utilizarea cardului cadou a eșuat.',
  },
  title: 'Utilizați card cadou',
  subtitle: 'Introduceți codul cardului cadou și suma de dedus din nota de plată a clientului.',
  form: {
    amount: {
      label: 'Suma de utilizat',
    },
    code: {
      label: 'Cod card cadou',
    },
  },
  buttons: {
    redeem: 'Utilizare',
    cancel: 'Anulare',
  },
};
